import { useState, useEffect } from "react";

export default function SplashScreen({ onFinished }) {
  const [phase, setPhase] = useState("show"); // show | fadeout | done

  useEffect(() => {
    const showTimer = setTimeout(() => setPhase("fadeout"), 2000);
    const doneTimer = setTimeout(() => {
      setPhase("done");
      onFinished();
    }, 2500);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(doneTimer);
    };
  }, [onFinished]);

  if (phase === "done") return null;

  return (
    <div
      className={`fixed inset-0 z-[200] bg-background flex flex-col items-center justify-center transition-opacity duration-500 ${
        phase === "fadeout" ? "opacity-0" : "opacity-100"
      }`}
      data-testid="splash-screen"
    >
      <div className="relative w-28 h-28 mb-6">
        <img
          src="/icon-192.png"
          alt="Culture Ken"
          className="w-28 h-28 rounded-3xl"
        />
        {/* Twinkle sparkle on the eye */}
        <svg
          className="absolute top-0 left-0 w-full h-full pointer-events-none"
          viewBox="0 0 112 112"
        >
          <g className="twinkle-star" style={{ transformOrigin: "52px 24px" }}>
            <line x1="52" y1="16" x2="52" y2="32" stroke="#FFF8E1" strokeWidth="3" strokeLinecap="round" />
            <line x1="44" y1="24" x2="60" y2="24" stroke="#FFF8E1" strokeWidth="3" strokeLinecap="round" />
            <line x1="46" y1="18" x2="58" y2="30" stroke="#FFF8E1" strokeWidth="2" strokeLinecap="round" />
            <line x1="58" y1="18" x2="46" y2="30" stroke="#FFF8E1" strokeWidth="2" strokeLinecap="round" />
            <circle cx="52" cy="24" r="2.5" fill="#FFFDE7" opacity="0.8" />
          </g>
        </svg>
      </div>
      <h1 className="text-2xl font-bold text-foreground tracking-wide">
        Culture Ken
      </h1>

      <style>{`
        .twinkle-star {
          animation: twinkle 1.2s ease-in-out infinite;
        }
        @keyframes twinkle {
          0%, 100% { opacity: 0; transform: scale(0.3) rotate(0deg); }
          50% { opacity: 1; transform: scale(1) rotate(15deg); }
        }
      `}</style>
    </div>
  );
}
